import { HomeVideoHistoryTablePage } from './HomeVideoHistoryTablePage';
export default HomeVideoHistoryTablePage;
